import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MainServiceService } from './main-service.service';
import { UserAccessStatus } from '../pages/page-admin-edit-colab/elements/tab-status-acesso/user-access-status.model';

@Injectable({
  providedIn: 'root',
})
export class StatusAccessService {
  private readonly tnwApi = environment.tnwApi;

  constructor(private readonly mainService: MainServiceService) {}

  getUserAccessStatus(idNewWizer: number): Observable<UserAccessStatus> {
    return this.mainService.request<UserAccessStatus>(
      'get',
      this.tnwApi,
      `api/v1/onboarding/user/${idNewWizer}/status`,
      null,
      'private'
    );
  }

  syncSso(id: number): Observable<any> {
    return this.mainService.request<any>(
      'post',
      this.tnwApi,
      'api/v1/onboarding/user/sso',
      { Id: id },
      'private'
    );
  }

  syncAd(id: number): Observable<any> {
    return this.mainService.request<any>(
      'post',
      this.tnwApi,
      'api/v1/onboarding/user/ad',
      { Id: id },
      'private'
    );
  }

  syncWizity(id: number): Observable<any> {
    return this.mainService.request<any>(
      'post',
      this.tnwApi,
      'api/v1/onboarding/user/wizity',
      { Id: id },
      'private'
    );
  }

  syncEmployee(id: number): Observable<any> {
    return this.mainService.request<any>(
      'post',
      this.tnwApi,
      'api/v1/onboarding/user/funcionario',
      { Id: id },
      'private'
    );
  }
}
